import { render } from "./StandardV2Header.vue?vue&type=template&id=398db6df&scoped=true"
import script from "./StandardV2Header.vue?vue&type=script&lang=js"
export * from "./StandardV2Header.vue?vue&type=script&lang=js"

import "./StandardV2Header.vue?vue&type=style&index=0&id=398db6df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398db6df"]])

export default __exports__